module.exports = __webpack_public_path__ + "img/airners-marketing-banner-background.27430cf8.png";